(function() {
	angular
		.module('main')
		.controller('ContactFormController', ContactFormController);

	ContactFormController.$inject = [
		'$scope',
		'$routeParams',
		'$location',
		'messageService'
	];

	function ContactFormController(
		$scope,
		$routeParams,
		$location,
		messageService
	) {
		$scope.$on('$viewContentLoaded', () => {
			if ($routeParams.closedWithError) {
				messageService.showErrorFromBackend(
					$routeParams.title,
					$routeParams.message
				);
				$location.search({});
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/contactFormController.js